__turbopack_context__.v({
  "scrollableRow": "styles-module__nY5YLW__scrollableRow",
});
